const OrderLogType = {
    statusUpdate: "status update",
    billableEdit: "billable edit",
};

export default OrderLogType;
